(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["freeswatch-hero"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('td-sticky-checkout-banner')) {
      class TdStickyCheckoutBanner extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;

          const section = this.closest('.shopify-section');
          if (section && section.parentElement) {
            document.querySelectorAll('td-sticky-checkout-banner.td-sticky-checkout-banner--moved').forEach(el => el.remove());
            this.classList.add('td-sticky-checkout-banner--moved');
            section.after(this);
          }

          document.addEventListener('td-swatch-visibility', (e) => {
            this.classList.toggle('is-visible', e.detail.visible);
          });

          if (Shopify.designMode) {
            document.addEventListener('shopify:section:load', () => {
              document.querySelectorAll('td-sticky-checkout-banner:not(.td-sticky-checkout-banner--moved)').forEach(el => {
                const section = el.closest('.shopify-section');
                if (section && section.parentElement) {
                  document.querySelectorAll('td-sticky-checkout-banner.td-sticky-checkout-banner--moved').forEach(old => old.remove());
                  el.classList.add('td-sticky-checkout-banner--moved');
                  el._initialized = true;
                  section.after(el);
                }
              });
            });
          }
        }
      }

      customElements.define('td-sticky-checkout-banner', TdStickyCheckoutBanner);
    }
  
  } catch(e) { console.error(e); }
})();
})();
